'use client'

import { cn } from '@paladise/ui/lib/utils'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'
import { tv } from 'tailwind-variants'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const themeStyles = tv({
  variants: {
    theme: {
      still: 'bg-glass-ios-20blur-still text-label-still-l1',
      light: 'bg-background-1st text-label-l1',
      dark: 'bg-floating-still text-label-still-l1',
    },
  },
})

export const TooltipArrow = TooltipPrimitive.Arrow

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    theme?: 'light' | 'still' | 'dark'
  }
>(({ className, sideOffset = 4, theme, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 text-caption shadow-floating z-50 overflow-hidden rounded-md px-3 py-2',
      themeStyles({ theme }),
      className,
    )}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger }
